import React from 'react';

export const BrandLogo = ({ className = 'h-10', alt = 'OpenSov AI' }) => (
  <>
    <img src="/logo-light.png" alt={alt} className={`object-contain dark:hidden ${className}`} />
    <img src="/logo-dark.png" alt={alt} className={`object-contain hidden dark:block ${className}`} />
  </>
);

export default BrandLogo;
